// extracted by mini-css-extract-plugin
module.exports = {"viewMainProposal":"src-containers-Proposal-Main-styles___viewMainProposal"};